const partnerNames = ['内容合作伙伴一', '内容合作伙伴二', '内容合作伙伴三', '内容合作伙伴四', '内容合作伙伴五', '内容合作伙伴六'];

export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <span className="text-lg md:text-xl font-black text-primary-400">51吃瓜视频</span>
            <p className="mt-3 text-xs md:text-sm text-foreground-300 leading-relaxed">
              51吃瓜视频在线观看高清免费播放，汇聚全网热门吃瓜视频资源，支持在线点播与免费看，每日更新最新爆料视频，即时满足你的吃瓜需求。
            </p>
            <div className="mt-4 flex items-center gap-3">
              <a href="#hero" className="w-8 h-8 rounded-full bg-foreground-700 flex items-center justify-center text-background-200 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="首页">
                <i className="ri-home-line text-sm"></i>
              </a>
              <span className="w-8 h-8 rounded-full bg-foreground-700 flex items-center justify-center text-background-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </span>
              <span className="w-8 h-8 rounded-full bg-foreground-700 flex items-center justify-center text-background-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </span>
            </div>
          </div>

          <div>
            <h3 className="text-sm md:text-base font-bold text-white">快速导航</h3>
            <ul className="mt-3 space-y-2">
              <li><a href="#ranking" className="text-xs md:text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">吃瓜热榜</a></li>
              <li><a href="#media" className="text-xs md:text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">精彩视频</a></li>
              <li><a href="#updates" className="text-xs md:text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">最新爆料</a></li>
              <li><a href="#faq" className="text-xs md:text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">吃瓜问答</a></li>
              <li><a href="#about" className="text-xs md:text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">关于我们</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm md:text-base font-bold text-white">热门分类</h3>
            <ul className="mt-3 space-y-2">
              <li><a href="#index" className="text-xs md:text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">娱乐圈八卦</a></li>
              <li><a href="#index" className="text-xs md:text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">网红爆料</a></li>
              <li><a href="#index" className="text-xs md:text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">社会热点</a></li>
              <li><a href="#index" className="text-xs md:text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">明星动态</a></li>
              <li><a href="#index" className="text-xs md:text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">综艺名场面</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm md:text-base font-bold text-white">合作伙伴</h3>
            <ul className="mt-3 space-y-2">
              {partnerNames.map((name) => (
                <li key={name} className="text-xs md:text-sm text-foreground-400">{name}</li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-8 md:mt-10 pt-6 border-t border-foreground-700 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; 2024-2026 51吃瓜视频 版权所有 | 本站内容来自全网公开渠道，仅供娱乐参考
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-400 cursor-pointer hover:text-foreground-200 transition-colors">用户协议</span>
            <span className="text-xs text-foreground-400 cursor-pointer hover:text-foreground-200 transition-colors">隐私政策</span>
            <span className="text-xs text-foreground-400 cursor-pointer hover:text-foreground-200 transition-colors">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}